import React from "react";
import StoreItemsList from "../component/StoreItemsList";

const StoreItemsListContainer = ({ pageId }) => (<StoreItemsList pageId={ pageId } />)

export default StoreItemsListContainer;